import {
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import { Button } from "newui/components/Button";
import { Input } from "components/RFQ/Input/Input";
import React, { useState } from "react";

const AddSectionModal = ({
	isOpen,
	onClose,
	OptionSections,
	addSectionHandler,
	addQuestionHandler,
	modalType,
	sections,
}) => {
	const isSection = modalType === "section" ? true : false;

	const questionOptions = sections
		?.map((section, index) => ({
			value: index,
			label: section.name
				? section.name.slice(0, 100)
				: "Unnamed Section " + (index + 1),
			isRemove: section.isRemove || 0,
		}))
		.filter((section) => !section.isRemove || section?.isRemove !== 1);

	const [selected, setSelected] = useState(questionOptions?.[0]?.value);

	const onClickAddSection = () => {
		if (isSection) {
			addSectionHandler();
		} else {
			addQuestionHandler(selected);
		}
		onClose();
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			autoFocus={false}
			returnFocusOnClose={false}
			isCentered
		>
			<ModalOverlay />
			<ModalContent containerProps={{ sx: { height: "100vh" } }}>
				<ModalHeader>
					<div>
						<h2 className="text-lg font-semibold text-primary-900">{`Add ${isSection ? "section" : "question"}`}</h2>
						<p className="text-sm font-normal text-tertiary-600">
							{isSection
								? "Create a new section to group your questions."
								: "Create a new question within the selected section below:"}
						</p>
					</div>
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Input
						label="Select section"
						placeholder={
							<Flex
								gap={3}
								align={"center"}
							>
								<Icon icon="section" />{" "}
								<div>Select {isSection ? "section" : "section"}</div>{" "}
							</Flex>
						}
						name="section"
						options={isSection ? OptionSections : questionOptions}
						type="select"
						value={selected}
						onChange={(e) => setSelected(e.value)}
					/>
				</ModalBody>

				<ModalFooter>
					<Flex
						gap={3}
						className="!w-full"
					>
						<Button
							btntype={"base"}
							style={{ width: "100%" }}
							onClick={onClose}
						>
							Cancel
						</Button>
						<Button
							style={{ width: "100%" }}
							onClick={onClickAddSection}
							data-testid="submit-button"
						>
							Confirm
						</Button>
					</Flex>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default AddSectionModal;
